import React, { useEffect } from "react";
import DataTable from "react-data-table-component";

import columns from "./Table/columns";
import data from "./Table/data";

import { useEditCoachPoolContext } from "../../../../contexts/EditCoachPoolContext";

export default function Table() {
  const { dispatch, actions, state } = useEditCoachPoolContext();

  useEffect(() => {
    actions.loadCoaches(dispatch);
  }, []);

  return (
    <>
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={data(state) || []}
          noDataComponent={
            <div className="mt20">
              {state.coaches == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
        />
      </div>
    </>
  );
}
